import * as React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import './PublicResults.css';

function PublicCatches () {

  const [catchList, setCatchList] = useState([]);

  useEffect(() => {

    let catchParams = {
      method: 'GET',
      url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getRecentCatches',
      headers: {'Content-Type': 'application/json'},
    }
    const getRecentCatches = async () =>{
      let response = await axios(catchParams);  
      setCatchList(response.data)
    }
    getRecentCatches();

  }, []);

  return (
    <>
      <div className="container">
        <h2>All Catches</h2>
        <div className="resultsTable">
          <Table>
            <Thead>
              <Tr>
                <Th>Species</Th>
                <Th>Boat</Th>
                <Th>Date</Th>
                <Th>Time (24h)</Th>
                <Th>Points</Th>
              </Tr>
            </Thead>
            <Tbody>
              {catchList.map((team, i) => {
                return (
                  <Tr>
                    <Td>{team.fish}</Td>
                    <Td>{team.boatName}</Td>
                    <Td>{team.date.split("T")[0]}</Td>
                    <Td>{team.time}</Td>
                    <Td>{team.points}</Td>
                  </Tr>
                )
              })}
            </Tbody>
          </Table>
        </div>
      </div>
      <br/>
      <br/> 
    </>
  );
}

export default PublicCatches;

